<div class="add-new-popup fixed inset-0 z-[999] overflow-hidden transition-all"
     [class.active]="classApplied()"
     (click)="onBackdropClick()">

    <div class="flex h-full w-full items-center justify-center p-4">

        <div class="dialog-panel relative max-h-full overflow-auto rounded-xl shadow-2xl transition-all"
             (click)="$event.stopPropagation()">
            <ng-template #contentAnchor></ng-template>
        </div>

    </div>
</div>

<!-- 

<div class="add-new-popup fixed inset-0 z-[999] overflow-x-hidden overflow-y-auto transition-all lg:py-[20px]"
     [class.active]="classApplied()">
             <div class="trezo-card-header -mx-[20px] -mt-[20px] mb-[20px] flex items-center justify-between rounded-t-md bg-gray-50 p-[20px] md:-mx-[25px] md:-mt-[25px] md:mb-[25px] md:p-[25px] dark:bg-[#15203c]">
               <div class="trezo-card-title">
                   <h5 class="!mb-0">
                       Modal Title
                   </h5>
               </div>
               <div class="trezo-card-subtitle">
                   <button type="button" class="leading-none text-[23px] text-black transition-all hover:text-primary-500 dark:text-white" (click)="close()">
                       <i class="ri-close-fill"></i>
                   </button>
               </div>
           </div>


           <div class="trezo-card-content pb-[20px] md:pb-[25px]">
               [<ng-template #contentAnchor></ng-template>]
           </div>


           <div class="trezo-card-footer -mx-[20px] flex items-center justify-between border-t border-gray-100 px-[20px] pt-[20px] md:-mx-[25px] md:px-[25px] md:pt-[25px] dark:border-[#172036]">
               <button class="bg-danger-500 border-danger-500 inline-block rounded-md border px-[30px] py-[10px] text-white transition-all hover:bg-danger-400 hover:border-danger-400"
                       type="button"
                       (click)="close()">
                   Close
               </button>
               <button class="bg-primary-500 border-primary-500 mb-[15px] inline-block rounded-md border px-[30px] py-[10px] text-white transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[11px] rtl:ml-[11px]"
                       type="button">
                   Save Changes
               </button>
           </div>


 -->
